module.exports = __webpack_public_path__ + "static/media/15@1920w.50f98905.jpg";